import { Icon } from '@octano/global-ui';
import { UncontrolledTooltip } from 'reactstrap';
import { ReactElement, useRef } from 'react';

export function PerformanceAnalysisTableTooltip({
  names,
  many,
  zero = '-',
}: {
  names: (string | ReactElement)[];
  many: string;
  zero?: string;
}) {
  const tooltipRef = useRef(null);
  return (
    <div
      className="d-flex justify-content-center"
      style={{ position: 'relative' }}
    >
      {!names.length && zero}
      {names.length === 1 && names[0]}
      {names.length > 1 ? (
        <>
          {many}
          <span className="ml-1" ref={tooltipRef}>
            <Icon name="information" />
          </span>
          <div>
            <UncontrolledTooltip
              target={tooltipRef}
              placement="auto-start"
              color="light"
              style={{ width: 'max-content', paddingLeft: 0, paddingRight: 30 }}
            >
              <ul className="mb-0">
                {names.map((name, index) => (
                  <li key={index}>{name}</li>
                ))}
              </ul>
            </UncontrolledTooltip>
          </div>
        </>
      ) : null}
    </div>
  );
}
